import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'ホーム', href: '/' },
    { name: '会社概要', href: '/about' },
    { name: 'サービス', href: '/services' },
    { name: '実績紹介', href: '/works' },
    { name: 'お客様の声', href: '/voice' },
    { name: 'ご依頼の流れ', href: '/flow' },
    { name: '採用情報', href: '/recruit' },
    { name: '協力会社募集', href: '/partner' },
    { name: 'お知らせ', href: '/news' },
    { name: 'お問い合わせ', href: '/contact' }
  ];

  const isActive = (href: string) => {
    return location.pathname === href;
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* ロゴ */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/623e13e0b4ee49abbabb458e9e3bf567.jpeg" 
              alt="SUNFIELD" 
              className="h-12 w-12 object-contain"
            />
            <span className="ml-3 text-xl font-bold text-blue-900"></span>
          </Link>

          {/* デスクトップナビゲーション */}
          <nav className="hidden xl:flex items-center space-x-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(item.href)
                    ? 'bg-blue-900 text-white'
                    : 'text-gray-700 hover:text-blue-900 hover:bg-blue-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTAボタン */}
          <div className="hidden xl:flex items-center space-x-4">
            <Link
              to="/contact"
              className="bg-yellow-400 text-blue-900 px-6 py-2 rounded-full font-bold hover:bg-yellow-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              お問い合わせ
            </Link>
          </div>

          {/* モバイルメニューボタン */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="xl:hidden p-2 rounded-md text-gray-700 hover:text-blue-900 hover:bg-blue-50 transition-colors duration-200 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* モバイルナビゲーション */}
        {isMenuOpen && (
          <div className="xl:hidden py-4 border-t border-gray-200">
            <nav className="space-y-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 cursor-pointer ${
                    isActive(item.href)
                      ? 'bg-blue-900 text-white'
                      : 'text-gray-700 hover:text-blue-900 hover:bg-blue-50'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/contact"
                onClick={() => setIsMenuOpen(false)}
                className="block bg-yellow-400 text-blue-900 px-3 py-2 rounded-md font-bold hover:bg-yellow-300 transition-colors duration-200 mt-4 cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                お問い合わせ
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
